'use client'

import { ApiReferenceReact } from '@scalar/api-reference-react'

import '@scalar/api-reference-react/style.css'

export default function PublicDocsPage() {
  return (
    <div className="h-dvh w-full overflow-y-auto overscroll-contain">
      <ApiReferenceReact
        configuration={{
          _integration: 'nextjs',
          url: '/api/v1/openapi.public.json',
        }}
      />
    </div>
  )
}
